import { useNavigate } from 'react-router-dom'

import { Button } from '@buffer-mono/popcorn'

import {
  settingsRoleAndPermissionsRoute,
  settingsTeamRoute,
} from '~publish/legacy/routes'
import { useCanAccessTeamFeatures } from '~publish/pages/Settings/Team/hooks/useCanAccessTeamFeatures'

import type { JSX } from 'react'

type ViewChannelPermissionsActionsProps = {
  /** Runs for both buttons, so navigating away also dismisses the overlay. */
  onDismiss: () => void
}

/**
 * "Got It" plus a link to where the member can read their own channel access,
 * shared by the view-only education overlays. The Team page shows every
 * member's role and access, so it is the destination when the member can
 * open it. Otherwise (a legacy organization, or a plan without the team panel)
 * the link opens Role & Permissions settings.
 */
export const ViewChannelPermissionsActions = ({
  onDismiss,
}: ViewChannelPermissionsActionsProps): JSX.Element => {
  const navigate = useNavigate()
  const { canAccessTeamFeatures } = useCanAccessTeamFeatures()

  return (
    <>
      <Button variant="secondary" size="medium" onClick={onDismiss}>
        Got It
      </Button>
      <Button
        variant="primary"
        size="medium"
        onClick={(): void => {
          onDismiss()
          navigate(
            canAccessTeamFeatures
              ? settingsTeamRoute.route
              : settingsRoleAndPermissionsRoute.route,
          )
        }}
      >
        {canAccessTeamFeatures ? 'View Team' : 'View Channel Permissions'}
      </Button>
    </>
  )
}
